/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import Moment from 'react-moment';

import styles from './DeliveryDetails.scss';

@translate()
@inject('assetStore')
@observer
export default class DeliveryDetails extends React.Component<*> {
  render() {
    const {
      t,
      assetStore: { asset },
    } = this.props;
    const { delivery } = asset;

    return (
      <div>
        <h3>{t('general:assets.labels.delivery_pickup_details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:labels.ship_date')}:</b>
              </td>
              <td>
                {asset.er_delivery_date ? (
                  <Moment date={asset.er_delivery_date} format="MMMM DD, YYYY" />
                ) : null}
              </td>
            </tr>
            {asset.asset_tracking_number && (
              <tr>
                <td>
                  <b>{t('general:labels.way_bill_no')}:</b>
                </td>
                <td>{asset.asset_tracking_number}</td>
              </tr>
            )}
            <tr>
              <td>
                <b>{t('general:labels.delivery_address')}:</b>
              </td>
              <td>
                <ul>
                  <li>{delivery.delivery_address1}</li>
                  <li>{delivery.delivery_address2}</li>
                  <li>{delivery.delivery_address3}</li>
                  <li>{delivery.delivery_address4}</li>
                  <li>{delivery.delivery_postcode}</li>
                  <li>{delivery.delivery_address5}</li>
                </ul>
              </td>
            </tr>
            {asset.er_collection_tracking_number && (
              <tr>
                <td>
                  <b>{t('general:labels.way_bill_no_collection')}:</b>
                </td>
                <td>{asset.er_collection_tracking_number}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}
